import React from "react";

const Orders = () => {
  return (
    <div className="overflow-scroll h-[100%] p-4">
      <h1 className="text-2xl font-bold">orders Content hj</h1>
    </div>
  );
};

export default Orders;
